<template>
    <div class="form-group">
        <label :for="label" v-if="label">
            {{ label.charAt(0).toUpperCase() + label.slice(1) }}
        </label>
        <textarea
            :id="inputId || undefined"
            ref="textarea"
            class="form-control"
            :class="[inputClass, { 'input-error': error }]"
            :value="modelValue"
            :placeholder="placeholder"
            :required="required"
            :disabled="disabled"
            :maxlength="maxLength || undefined"
            rows="4"
            @input="$emit('update:modelValue', $event.target.value)"
            @blur="$emit('blurred')"
        ></textarea>
        <span v-if="error" class="error-text"> {{ error }} ⚠ </span>
    </div>
</template>

<script>
export default {
    name: "FlatTextarea",
    props: {
        modelValue: String,
        inputId: {
            type: String,
            default: "",
        },
        label: String,
        placeholder: String,
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: Number,
            default: null,
        },
        error: String,
        inputClass: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped>
.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #555;
    text-align: left;
}

.flat-input {
    width: 100%;
    padding: 12px;
    border: none;
    background: #f9f9ff;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: 0.3s;
    resize: vertical;
}
.flat-input:focus {
    background: #eefbf1;
}

.input-error {
    border: 1px solid #dc3545;
    background-color: #fff6f6;
}

.error-text {
    color: red;
    font-size: 12px;
    margin-top: 3px;
    display: block;
}
</style>
